(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seasonal-ebook-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sj-home-ebook')) {
    customElements.define('sj-home-ebook', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const form = this.querySelector('form');
        const button = this.querySelector('[data-home-add]');
        if (!form || !button) return;
        form.addEventListener('submit', async (event) => {
          if (event.submitter && event.submitter !== button) return;
          event.preventDefault();
          if (button.disabled) return;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          const feedback = this.querySelector('.sj-home-ebook__feedback');
          const status = feedback.querySelector('[role="status"]');
          feedback.hidden = true;
          try {
            const base = window.routes?.cart_add_url || '/cart/add';
            const response = await fetch(base.endsWith('.js') ? base : base + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);
            status.textContent = this.dataset.added;
            feedback.hidden = false;
            try {
              const cartBase = window.routes?.cart_url || '/cart';
              const cartResponse = await fetch(cartBase.endsWith('.js') ? cartBase : cartBase + '.js', { headers: { Accept: 'application/json' } });
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                document.querySelectorAll('.cart-count, .cart-count-drawer').forEach((node) => { node.textContent = cart.item_count; });
              }
            } catch (_) {}
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
            feedback.hidden = false;
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-evergreen-festival"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('.sj-eg[data-festival]').forEach(root => {
      if (root.dataset.enhanced) return;
      root.dataset.enhanced = 'true';
      const controls = root.querySelector('[data-year-controls]');
      const panels = [...root.querySelectorAll('[data-year-panel]')];
      const buttons = [...root.querySelectorAll('[data-year-button]')];
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).map(part => [part.type, part.value]));
      const today = parts.year + '-' + parts.month + '-' + parts.day;
      function select(year, track) {
        panels.forEach(panel => { panel.hidden = panel.dataset.yearPanel !== year; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.yearButton === year)));
        const panel = panels.find(item => item.dataset.yearPanel === year);
        const next = root.querySelector('[data-next-observance]');
        const headline = panel && panel.querySelector('[data-headline-date]');
        if (next && headline) { next.textContent = headline.textContent; next.dataset.date = headline.dateTime; }
        const heroContext = root.querySelector('[data-hero-panchang]');
        const selectedContext = panel && panel.querySelector('[data-headline-panchang]');
        if (heroContext && selectedContext) heroContext.innerHTML = selectedContext.innerHTML;
        if (track && Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'sj_festival_year_select', festival: root.dataset.festival, year });
      }
      if (controls && buttons.length) {
        controls.hidden = false;
        const year = today.slice(0, 4);
        select(buttons.some(button => button.dataset.yearButton === year) ? year : buttons[buttons.length - 1].dataset.yearButton, false);
        buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.yearButton, true)));
      }
      const expiry = root.querySelector('[data-expiry-note]');
      if (expiry && today.slice(0, 4) > '2027') expiry.hidden = false;
      function trackCommerce(name, form) {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, festival: root.dataset.festival, product_handle: form.dataset.productHandle, variant_id: form.querySelector('[name="id"]')?.value, placement: form.dataset.placement });
      }
      async function addItem(form, buyNow) {
        const status = form.querySelector('[data-commerce-status]');
        const error = form.querySelector('[data-commerce-error]');
        if (root.hasAttribute('data-commerce-preview')) {
          if (status) status.hidden = false;
          trackCommerce('sj_festival_preview_cta', form);
          return;
        }
        if (form.dataset.busy === 'true') return;
        form.dataset.busy = 'true';
        if (status) status.hidden = true;
        if (error) error.hidden = true;
        const controls = [...form.querySelectorAll('button,select')];
        const body = new FormData(form);
        if (!buyNow) { body.append('sections', 'minicart-form'); body.append('sections_url', window.location.pathname); }
        controls.forEach(control => { control.disabled = true; });
        try {
          const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
          if (!response.ok) throw new Error('cart_add_failed');
          const item = await response.json();
          trackCommerce(buyNow ? 'sj_festival_buy_now' : 'sj_festival_add_to_cart', form);
          if (buyNow) window.location.assign(root.dataset.checkoutUrl);
          else {
            if (status) status.hidden = false;
            try {
              const markup = item.sections?.['minicart-form'];
              const target = document.getElementById('minicart-form');
              const fresh = markup && new DOMParser().parseFromString(markup, 'text/html').querySelector('#minicart-form');
              if (target && fresh) target.innerHTML = fresh.innerHTML;
              const cartUrl = root.dataset.cartAddUrl.replace('/add.js', '.js');
              const cartResponse = await fetch(cartUrl, { credentials:'same-origin', headers:{Accept:'application/json'}, cache:'no-store' });
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                document.querySelectorAll('.cart-count').forEach(count => { count.textContent = count.classList.contains('cart-count-drawer') ? '(' + cart.item_count + ')' : cart.item_count > 100 ? '~' : cart.item_count; });
                const total = document.querySelector('header-total-price');
                if (typeof total?.updateTotal === 'function') total.updateTotal(cart);
                const shipping = document.querySelector('free-ship-progress-bar');
                if (typeof shipping?.init === 'function') shipping.init(cart.items_subtotal_price);
              }
            } catch {}
            document.dispatchEvent(new CustomEvent('sj:cart:updated', { detail: { item, origin: 'evergreen-guide' } }));
          }
        } catch {
          if (error) error.hidden = false;
        } finally {
          form.dataset.busy = 'false';
          controls.forEach(control => { control.disabled = false; });
        }
      }
      root.querySelectorAll('[data-buy-now]').forEach(button => { button.hidden = false; button.disabled = false; });
      if (root.hasAttribute('data-commerce-preview')) root.querySelectorAll('.sj-eg__form button').forEach(button => { button.disabled = false; });
      root.querySelectorAll('.sj-eg__form select').forEach(select => select.addEventListener('change', () => {
        const price = select.closest('.sj-eg__product').querySelector('[data-selected-price]');
        if (price) price.textContent = select.selectedOptions[0].dataset.priceLabel;
      }));
      root.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('.sj-eg__form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        addItem(form, false);
      }, true);
      root.addEventListener('click', event => {
        const buy = event.target.closest('[data-buy-now]');
        if (buy && root.contains(buy)) { event.preventDefault(); addItem(buy.closest('form'), true); return; }
        const link = event.target.closest('a[data-sj-event]');
        if (!link || !root.contains(link) || !Array.isArray(window.dataLayer)) return;
        window.dataLayer.push({ event: link.dataset.sjEvent, festival: root.dataset.festival, product_handle: link.dataset.productHandle || undefined, placement: link.dataset.placement || 'guide' });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-floating-product-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sj-product-marquee')) {
    customElements.define('sj-product-marquee', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.sj-product-marquee__pause');
        if (!button) return;

        button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', paused ? 'true' : 'false');
          button.setAttribute('aria-label', paused ? 'Play product animation' : 'Pause product animation');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
